import styles from './GenerateReportDrawer.styles'
import DrawerWithTitleAndFooter from '../../../../components/drawer/DrawerWithTitleAndFooter'
import CalendarInput from '../../../../components/input/calendarinput/CalendarInput'
import CheckboxWLabel from '../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'

import RadioInput from '../../../../components/input/radioinput/RadioInput'
import RadioInputWCard from '../../../../components/input/radioinput/radioinputwcard/RadioInputWCard'
import CalendarInputWDateFormat from '../../../../components/input/calendarinput/CalendarInputWDateFormat'
import DateUtils from '../../../../../libs/utility/DateUtils'

export default function GenerateReportDrawer({
    isOpen,
    title,
    onCloseCb,
    backButtonProp = {
        backCb: () => { },
        text: "Back",
    },
    submitButtonProp = {
        submitCb: () => { },
        text: "Next",
    },
    reportsHeaders = [],
    optionalInformation = {},
    onChangeReportHeadersCb = () => { },
    onChangeSelectAllCb = () => { },
    onChangeFileFormatCb = () => { },
    onChangeCalendarInputCb = () => { }
}) {

    const handleCalendarInputChange = (value, name) => {
        const updatedEventObj = {
            target: {
                name: name,
                value: value,
            }
        }
        onChangeCalendarInputCb(updatedEventObj)
    }
    return (
        <>
            <DrawerWithTitleAndFooter
                isOpen={isOpen}
                onCloseCb={onCloseCb}
                title={title}
                backButtonProp={backButtonProp}
                submitButtonProp={submitButtonProp}
            >

                <div>
                    <div>
                        <label style={styles.lableText}>Select the dates for report</label>
                        <div style={styles.calendarBox}>
                            <CalendarInputWDateFormat
                                name={`fromDate`}
                                label={'FROM'}
                                value={optionalInformation.fromDate}
                                customStyle={styles.calendar}
                                onChangeCb={e => handleCalendarInputChange(e, `fromDate`)}
                                maxAllowedDate={DateUtils.getMomentObject(new Date())}
                            />
                            <CalendarInputWDateFormat
                                name={`toDate`}
                                label={'TO'}
                                value={optionalInformation.toDate}
                                customStyle={styles.calendar}
                                onChangeCb={e => handleCalendarInputChange(e, `toDate`)}
                                maxAllowedDate={DateUtils.getMomentObject(new Date())}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <label style={styles.lableText}>Select file format to export</label>
                    <div style={styles.extensionContainer}>

                        <RadioInputWCard
                            name="extension"
                            label={
                                { prefixLabel: ". xlsx" }
                            }
                            value={"XLSX"}
                            checked={optionalInformation.extension == 'XLSX' ? true : false}
                            onChangeCb={onChangeFileFormatCb}
                            iconName={VEC_ICON_NAME.EXCEL_SHEET_LOGO}
                        />

                    </div>
                </div>

                <div>
                    <label style={styles.lableText}>Select headers for report</label>
                    <div>
                        <div style={styles.selectAllCBox}>
                            <CheckboxWLabel checked={reportsHeaders.some(item => item.checked)} iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON} label="Select All" name="selectAll" onChangeCb={onChangeSelectAllCb} />
                        </div>

                        <HorizontalSeparator style={styles.horizontalLine} />

                        <div style={styles.checkboxContainer}>

                            {reportsHeaders.map((item, idx) => (
                                <CheckboxWLabel iconName={VEC_ICON_NAME.CHECKBOX_ICON} label={item.Label} name={item.Name} checked={item.checked} onChangeCb={(event) => onChangeReportHeadersCb(event, idx)} />
                            ))}
                        </div>
                    </div>
                </div>
            </DrawerWithTitleAndFooter>
        </>
    )
}
